import React from 'react';

export const childProps = (child, props) => {
  return typeof child === 'function'
    ? child(props)
    : React.cloneElement(React.Children.only(child), props);
};



// WEBPACK FOOTER //
// ./src/utils/index.js